import { render, staticRenderFns } from "./QuickNoteForm.vue?vue&type=template&id=7585f4ce&"
import script from "./QuickNoteForm.vue?vue&type=script&lang=js&"
export * from "./QuickNoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports